/**************************************************
 * Nombre:       Tarjeta_Servicios
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {CalendarMonth} from '@mui/icons-material'
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";

const Tarjeta_Servicios = ({item}) => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                p: sCell ? 2 : 4,
                background: 'rgba(255, 255, 255, 0.14)',
                backdropFilter: 'blur(5px)',
                borderRadius: 4
            }}
        >

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                <item.icono sx={{fill: '#fff', width: 60, height: 60}}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 2}}>
                <Typography sx={{
                    fontFamily: 'Raleway',
                    fontSize: 24,
                    fontWeight: 800,
                    textAlign: 'center',
                    lineHeight: 1.2,
                }}>{item.nombre}</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 1}}>
                <Typography
                    sx={{fontFamily: 'Raleway', fontSize: 16, fontWeight: 300, color: '#C4C4C4', textAlign: 'center'}}>
                    {item.descripcion}
                </Typography>
            </Grid>


        </Grid>
    )

}
export default Tarjeta_Servicios    